export default {
    title: '수업 기록',
    pageTitle: {
        lecture: '수업 리포트',
        self: '자습 리포트',
        proto: '씨앗글자 기록',
    },
    history: {
        lectrue: '수업 히스토리',
        self: '자습 히스토리',
        detail: {
            lectrueStart: '{mode} 시작',
            end: {
                title: '{mode} 종료',
                duration: '(소요 시간: {duration}분)',
            },
            zeroLog: '{mode} 로그가 없습니다.',
        },
    },
    navigation: {
        lectrue: {
            history: '수업 기록',
            report: '수업 리포트',
        },
        self: {
            history: '자습 기록',
            report: '자습 리포트',
        },
    },
    tab: {
        lacture: '수업',
        self: '자습',
        protoWord: '씨앗글자',
    },
    emptyMessage: {
        lacture: '진행한 수업이 없어요.',
        self: '진행한 자습이 없어요.',
        protoWord: '씨앗글자 학습 내역이 없어요.',
    },
    table: {
        modules: '활동수',
        students: '참여 학생수',
        mvps: 'MVP',
        spentTime: '소요 시간',
        startDate: '시작',
        endDate: '종료',
        studyDate: '학습일',
        studentName: '학생 이름',
        level: '레벨',
        round: '회차',
        learnedLetters: '배운 글자',
        date: '일자',
        activity: '활동수',
        achievement: '성취도',
        sessionTitle: '수업명',
        selfModeTitle: '자습명',
    },
    confirmDelete: {
        title: {
            lacture: '수업 기록 삭제',
            self: '자습 기록 삭제',
            protoWord: '씨앗글자 기록 삭제',
        },
        message: {
            lacture: '수업을 삭제할까요?\n삭제 시 복구되지 않고, 학급 성취도 평균에 영향을 줄 수 있어요.',
            self: '자습을 삭제할까요?\n삭제 시 복구되지 않고, 학급 성취도 평균에 영향을 줄 수 있어요.',
            protoWord: '씨앗글자를 삭제할까요?\n삭제 시 복구되지 않고, 학급 성취도 평균에 영향을 줄 수 있어요.',
            confirmDelete: '정말 삭제하시겠어요?',
        },
    },
    search: {
        student: '학생 이름 검색',
        all: '전체',
    },
    summary: {
        title: '수업 내용',
        mvp: {
            achievement: '성취도',
            noContent: 'MVP가 없어요',
            tooltip:
                'MVP는 모든 활동에 참여한 학생 중 성취도가 높은 학생이에요.\n동점이라면 획득한 칭찬별 순으로 선정돼요.',
        },
        graph: {
            average: '평균 성취도',
            current: '본 수업',
            total: '전체',
        },
        self: {
            title: '자습 내용',
            noContent: '자습 내용 없음',
            history: '자습 히스토리',
            button: '자습 결과 다시 보기',
            restartButton: '자습 다시 하기',
        },
        lecture: {
            title: '수업 내용',
            noContent: '수업 내용 없음',
            history: '수업 히스토리',
            button: '수업 결과 다시 보기',
            restartButton: '수업 다시 하기',
        },
        history: {
            student: '참여 학생',
            date: '수업 일자',
            duration: '소요 시간',
            start: '시작',
            end: '종료',
        },
    },
    moduleDetail: {
        title: '활동별 결과',
        emptyMessage: '기록된 활동이 없어요.',
        result: {
            title: '{mode} 결과',
        },
        table: {
            no: '순번',
            activity: '활동',
            time: '소요시간',
            score: '성취도',
            result: '결과',
            champion: '챔피언',
            averageScore: '평균 성취도',
            action: '결과보기',
        },
    },
    studentDetail: {
        title: '학생별 결과',
        search: {
            title: '학생 이름 검색',
            all: '전체',
        },
        emptyMessage: {
            notParticipate: '참여한 학생이 없어요.',
            noAchievement: '기록된 활동이 없어요.',
        },
        info: {
            message: 'ⓘ 성취도가 있는 활동만 표시됩니다. (단어 추리하기, 차근차근 읽기, 와글와글은 표시되지 않아요)',
        },
    },
};
